import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Flex, Spin } from 'antd';
import React from 'react';
import { useTemplates } from '~/hooks/useConversations';

function TemplatesList({ activeMerchantId, onBack, onSelect }) {
  const { isLoading, data: templates = [] } = useTemplates(activeMerchantId);

  const grouped = templates?.reduce((acc, t) => {
    if (!acc[t.contact_reason]) acc[t.contact_reason] = { label: t.contact_reason_label, items: [] };
    acc[t.contact_reason].items.push(t);
    return acc;
  }, {});

  return (
    <>
      <Flex align='center' gap={16} className='h-[62px] mt-[-16px]'>
        <Button type='text' size='large' className='btn-icon btn-dark' icon={<ArrowLeftOutlined />} onClick={onBack} />
        <h3 className='h3'>Modèles de messages</h3>
      </Flex>
      <Flex vertical gap={24} className='pt-l overflow-y-auto max-h-[80vh]'>
        {isLoading ? (
          <Spin className='w-full flex justify-center items-center h-[300px]' />
        ) : (
          <>
            {Object.keys(grouped).length === 0 && <p className='body1 text-grey-medium'>Aucun modèle de message disponible.</p>}
            <Flex vertical gap={16}>
              {Object.entries(grouped)
                .sort(([a], [b]) => (a === 'other') - (b === 'other'))
                .map(([reason, group]) => (
                  <Flex key={reason} vertical gap={16}>
                    <p className='sub1'>{group.label}</p>
                    <div className='grid grid-cols-2 gap-s'>
                      {group.items.map((template) => (
                        <Flex
                          key={template.id}
                          className='cursor-pointer rounded-sm bg-info-light py-xl px-s'
                          justify='center'
                          align='center'
                          onClick={() => onSelect(template)}
                        >
                          <p className='body1'>{template.title}</p>
                        </Flex>
                      ))}
                    </div>
                  </Flex>
                ))}
            </Flex>
            <Flex align='center' gap={24} className='p-m bg-creme-background' justify='space-between'>
              <p className='body1'>
                Si vous souhaitez créer un nouveau modèle, suggérez le à l’équipe SAV Label Emmaüs.
                <br />
                Si vous en avez besoin, c’est probablement le cas d’autres boutiques !
              </p>
              <Button type='primary' href='mailto:sav@label-emmaus.co'>
                Suggérer un nouveau modèle
              </Button>
            </Flex>
          </>
        )}
      </Flex>
    </>
  );
}

export default TemplatesList;
